module.exports = __webpack_public_path__ + "static/media/knoldge.78ccc254.jpg";